
    import './styles.scoped.css';
    export default {
  "token": "awsui_token_v05f6_c8hk2_5"
};
  